module.exports = __webpack_public_path__ + "static/media/CleverbitLogo.8b58c9ac.png";